import React, { useState, useEffect } from "react";
import { me, UserResponse } from "../interface/user";

function Profile() {
    const [ user, setUser ] = useState<UserResponse | null>(null);
    
    useEffect(() => {
        me().then(response => {
            setUser(response.data);
        }).catch(error => {
            console.error(error);
        });
    }, []);

    return (
        <main style={{height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
            <div id={"profile-page"}>
                <h1>Profile</h1>
                <p>
                    <i>{user?.user.nickname}</i>
                </p>
            </div>
        </main>
    );
}

export default Profile;